import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Box, Typography } from '@mui/material';
import { ApiRequest } from '../../services/api';

const NewTip = () => {
  const [tip, setTip] = useState({
    titulo: '',
    descripcion: '',
    cuerpo: '',
    imagen: ''
  });
  const [imagePreview, setImagePreview] = useState(''); // Para vista previa de imagen
  const navigate = useNavigate();

  // Guardar tip
  const handleSave = async () => {
    const tipData = {
      Titulo: tip.titulo,
      Descripcion: tip.descripcion,
      Cuerpo: tip.cuerpo,
      ImagenBase64: tip.imagen,
    };

    try {
      await ApiRequest('api/Tips/AgregarTip', 'POST', tipData); // Enviar datos al API
      navigate('/Dashboard/Tips');
    } catch (error) {
      console.error('Error saving new tip:', error);
    }
  };

  // Cargar imagen
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      const base64String = reader.result;
      // Extraer solo la parte Base64 eliminando el prefijo "data:image/jpeg;base64,"
      const base64Image = base64String.split(',')[1];
      setTip({ ...tip, imagen: base64Image });
      setImagePreview(base64String); // Mostrar vista previa
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h4" gutterBottom>
        Agregar Tip
      </Typography>

      {/* Campo Nombre */}
      <TextField
        label="Titulo"
        value={tip.titulo}
        onChange={(e) => setTip({ ...tip, titulo: e.target.value })}
        fullWidth
        margin="normal"
      />

      {/* Campo Descripción */}
      <TextField
        label="Descripción"
        value={tip.descripcion}
        onChange={(e) => setTip({ ...tip, descripcion: e.target.value })}
        fullWidth
        margin="normal"
        multiline
        rows={4}
      />

      {/* Campo Cuerpo */}
      <TextField
        label="Cuerpo"
        value={tip.cuerpo}
        onChange={(e) => setTip({ ...tip, cuerpo: e.target.value })}
        fullWidth
        margin="normal"
        multiline
        rows={6}
      />

      {/* Imagen del Tip */}
      <Typography variant="h6" gutterBottom>
        Imagen del Tip
      </Typography>
      <input type="file" accept="image/*" onChange={handleImageChange} />
      {imagePreview && (
        <Box mt={2}>
          <img src={imagePreview} alt="Vista previa del Tip" style={{ width: '100%', maxHeight: '300px', objectFit: 'contain' }} />
        </Box>
      )}

      {/* Botón para guardar */}
      <Button
        variant="contained"
        color="primary"
        onClick={handleSave}
        sx={{ mt: 2 }}
      >
        Guardar
      </Button>
    </Box>
  );
};

export default NewTip;
